import { useState, useEffect } from 'react';
import { api } from '../../services/api';
import { ListNumbers } from '@phosphor-icons/react';
import { STATUS_COLORS } from './constants';

const COUNTER_COLS = ['Presente', 'Assente', 'Assente Ingiustificato', 'Insegnante Assente', 'Festivo', ''];

export const StatisticsView = ({ anno }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = anno ? { anno } : {};
    api.getTeacherAttendanceCounter(params)
      .then(res => setData(res.data.students || []))
      .catch(err => console.error('Error loading attendance counter:', err))
      .finally(() => setLoading(false));
  }, [anno]);

  const getTotal = (counts) => (counts['Presente'] || 0) + (counts['Assente'] || 0) + (counts['Assente Ingiustificato'] || 0);

  if (loading) return <div className="text-center py-12 text-[#52525B]">Caricamento...</div>;

  if (!data.length) {
    return (
      <div className="text-center py-16 bg-white border border-[#E4E4E7] rounded-sm">
        <ListNumbers size={48} className="mx-auto text-[#E4E4E7] mb-4" />
        <p className="text-[#52525B]">Nessun dato presenze disponibile</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto -mx-3 sm:mx-0 px-3 sm:px-0">
      <div className="text-sm text-[#52525B] font-medium mb-3">{data.length} alunni</div>
      <div className="bg-white border border-[#E4E4E7] rounded-sm overflow-hidden">
        <table className="w-full" data-testid="teacher-attendance-counter-table">
          <thead>
            <tr className="border-b border-[#E4E4E7] bg-[#FAFAFA]">
              <th className="text-left px-3 py-2 text-xs font-semibold uppercase tracking-wider text-[#52525B] sticky left-0 bg-[#FAFAFA] min-w-[180px]">Alunno</th>
              {COUNTER_COLS.map(col => (
                <th key={col || 'vuoto'} className={`text-center px-2 py-2 text-[10px] font-semibold uppercase tracking-wider min-w-[70px] ${STATUS_COLORS[col] || 'text-gray-600'}`}>
                  {col || 'Vuote'}
                </th>
              ))}
              <th className="text-center px-3 py-2 text-xs font-semibold uppercase tracking-wider text-[#2D2A4A] bg-[#EEF2FF] min-w-[60px]">Totale</th>
            </tr>
          </thead>
          <tbody>
            {data.map(s => (
              <tr key={s.student_name} className="border-b border-[#E4E4E7] hover:bg-[#FAFAFA]">
                <td className="px-3 py-1.5 text-sm font-medium uppercase sticky left-0 bg-white">{s.student_name}</td>
                {COUNTER_COLS.map(col => {
                  const val = s.counts[col] || 0;
                  return (
                    <td key={col || 'vuoto'} className="text-center px-2 py-1.5">
                      {val > 0
                        ? <span className={`inline-block min-w-[28px] text-xs font-bold px-1.5 py-0.5 rounded ${STATUS_COLORS[col] || 'bg-gray-100 text-gray-700'}`}>{val}</span>
                        : <span className="text-xs text-[#D4D4D8]">-</span>}
                    </td>
                  );
                })}
                <td className="text-center px-3 py-1.5"><span className="inline-block min-w-[28px] text-xs font-bold px-1.5 py-0.5 rounded bg-[#EEF2FF] text-[#2D2A4A]">{getTotal(s.counts)}</span></td>
              </tr>
            ))}
            {/* Totals row */}
            <tr className="bg-[#FAFAFA] border-t-2 border-[#E4E4E7]">
              <td className="px-3 py-2 text-sm font-bold uppercase sticky left-0 bg-[#FAFAFA]">TOTALE</td>
              {COUNTER_COLS.map(col => {
                const total = data.reduce((sum, s) => sum + (s.counts[col] || 0), 0);
                return <td key={col || 'vuoto'} className="text-center px-2 py-2"><span className="text-xs font-bold">{total || '-'}</span></td>;
              })}
              <td className="text-center px-3 py-2"><span className="text-sm font-bold text-[#2D2A4A]">{data.reduce((sum, s) => sum + getTotal(s.counts), 0)}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
